import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputDateAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['type', HTTPINPUTTYPE.DATE]
]);
export const inputDateData = makeDataStruct([]);
export const inputDateModel = makeStruct([
    ['attributes', inputDateAttr],
    ['data', inputDateData]
]);
// Class
export default class INPUTDATETIME extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
    activate(event) { }
    deactivate(event) { }
}
